import React from 'react'

const ShowCategories = ({ title, categories }) => (
  <>
    {categories.length > 0 ? (
      <strong>{title}: </strong>
    ) : null}
    {categories
      .sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name))
      .map(category => (<span key={category.id}>{category.name}</span>))
      .reduce((acc, x) => acc === null ? [x] : [acc, ', ', x], null)}
  </>
)

export default ShowCategories
